import { useEffect, useState } from 'react'
import CMS from '../../../components/cms/CMS'
import PageBanner from '../../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { SortableList } from '../../../components/form/SortedBy'
import { fetchShowcaseSort } from '../../../redux/slices/showcaseSortSlice'
import { fetchShowcaseDelete } from '../../../redux/slices/showcaseDeleteSlice'
import { useParams } from 'react-router-dom'
import { fetchPageGet } from '../../../redux/slices/pageGetSlice'
import CrudShowcasePage from './CrudShowcasePage'
import CMSTemplate from '../../../components/cms-template'

const PageShowcase = () => {
    const { id } = useParams()
    const { t } = useTranslation()
    const [modal, setModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const [changed, setChanged] = useState(false)
    const page = useSelector((state) => state.pageGet.data)
    const status = useSelector((state) => state.pageGet.status)
    const lang = useSelector((state) => state.lang.lang)
    const isTemplate = useSelector((state) => state.isTemplate.isTemplate)
    const dispatch = useDispatch()

    const getData = async () => {
        await dispatch(fetchPageGet({ id: id }))
        setChanged(false)
    }

    const handleSorted = (newList) => {
        page?.showcases?.forEach(async (oldItem, oldIndex) => {
            const newIndex = newList.findIndex(item => item.id === oldItem.id);
            await dispatch(fetchShowcaseSort({ id: oldItem.id, sort: newIndex + 1 }))
            setChanged(true)
            getData()
        });
    };

    useEffect(() => {
        getData()
    }, [dispatch, changed])

    const deleteData = async (id) => {
        await dispatch(fetchShowcaseDelete({ id: id }))
        getData()
    }

    return (
        <CMS>
            <PageBanner
                modal={modal}
                setModal={setModal}
                title={page?.title[lang]}
                description={t("page_management_desc")}
                buttonText={t("add_showcase")}
            />

            {status === "succeeded" && !isTemplate ?
                <SortableList
                    setModal={setModal}
                    list={page?.showcases ? [...page?.showcases].sort((a, b) => a.sort - b.sort) : []}
                    onChange={handleSorted}
                    setChanged={setChanged}
                    deleteData={deleteData}
                    contentTitle={t("item")}
                    contentUrl="/page-showcase-item"
                    setSelectedItem={setSelectedItem}
                /> : null
            }

            <CrudShowcasePage
                showMenu={modal}
                setShowMenu={setModal}
                selectedItem={selectedItem}
                setChanged={setChanged}
                setSelectedItem={setSelectedItem}
                id={id}
                t={t}
            />
        </CMS>
    )
}

export default PageShowcase
